import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableRouteResourceIndex = Loadable({
  loader: () => import('./RouteResourceIndexContainer.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableRouteResourceIndex
